import { mapAssigneesListToOptions, sequence } from '@/ui/helpers';
import { filter as getAllUsers } from '@/services/api/resources/user';
import { filter as getAllGroups } from '@/services/api/resources/group';
import { useTask } from '@/ui/concerns';
import { ref } from 'vue';
import { SelectOptions } from '@/ui/types';
import { useRRule } from '@/ui/concerns/rrule/useRRule';
import { Schedule } from '@/entities/analytics-schedule';
import { get } from '@/services/api/resources/analytics-scheduler/actions';
import { intoEditable } from '@/services/api/resources/analytics-scheduler';
import { useScheduleStore } from '@/stores/analytics/schedule/schedule';

const { emptyRule } = useRRule();

export const scheduleRecord = () => <Schedule>({
  rule: emptyRule(),
  assignees: [],
  assignedGroups: [],
});

export function useSchedule(id?: number | null | undefined) {
  const store = useScheduleStore();
  const record = ref<Schedule>(store.record);
  const assigneeOptions = ref<SelectOptions<string>>([]);

  const scheduleUserOptions = () => sequence(
    getAllUsers(),
    getAllGroups(),
  );

  const getRecord = useTask(
    () => sequence(
      get(id!),
      scheduleUserOptions(),
    ),
    ([{ data, version }, [users, groups]]) => {
      store.setId(id!);
      setScheduleOptions(users, groups);
      store.setRecord(intoEditable(data));
      store.setVersion(version);
      record.value = intoEditable(data);
    },
  );

  const getUserOptions = useTask(
    () => scheduleUserOptions(),
    ([users, groups]) => {
      setScheduleOptions(users, groups);
    },
  );

  const getTask = id ? getRecord : getUserOptions;

  const setScheduleOptions = (
    users: BaseFilters,
    groups: BaseFilters,
  ) => {
    assigneeOptions.value = mapAssigneesListToOptions(users.data, groups.data);
  };

  const refreshUserOptions = () => {
    getUserOptions.run();
  };

  return {
    record,
    store,
    getTask,
    assigneeOptions,
    refreshUserOptions,
  };
}
